import { NgZone } from '@angular/core';
import { Store } from '@ngrx/store';
import { RouteGroupRule } from '@rocksoft/shared';
import { DeviceActiveSyncsStoreActions } from '../sub-features/device-sync/device-active-syncs-store';

/**
 * Creates route group rules for the Locations MDM hub
 */
export function createLocationsMdmRules(store: Store, zone: NgZone): RouteGroupRule[] {
  return [
    // Devices route - handles active device sync count updates
    {
      name: 'active-sync-monitoring-group',
      urlPattern: /^\/devices/,
      hub: 'locations-mdm',
      groupName: 'active-sync-monitoring',
      eventHandlers: [
        {
          eventName: 'OnActiveDeviceSyncsRetrieved',
          handler: (currentActiveSyncs: number) => {
            zone.run(() => {
              store.dispatch(
                DeviceActiveSyncsStoreActions.SignalRActions.activeDeviceSyncsUpdated({ currentActiveSyncs })
              );
            });
          },
        },
      ],
    },
  ];
}
